import { useEffect } from 'react';
import { useCompassCard } from '@scale/compass-ui/store';
import type { AutoReviewerContext } from '@scale/genai-compass-shared/cards/autoreviewer';
import { FilterGroup, isValidFilterGroup } from '@scale/compass-shared/filter';
import { useProjectId } from 'react-scale/corp/views/CorpProjectGroupManager/hooks/useProjectId';

function useArchieQCResultsAdapterCard(index: number) {
  const { card, updateCardContext, updateCardCanSubmit } = useCompassCard(index);
  const context = card.defaultContext as AutoReviewerContext;
  const projectId = useProjectId();

  const setFilter = (filter: FilterGroup) => {
    const updatedContext: AutoReviewerContext = {
      ...context,
      filter,
    };
    updateCardContext(updatedContext);
  };

  useEffect(() => {
    updateCardCanSubmit(isValidFilterGroup(context.filter));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.filter]);

  useEffect(() => {
    const updatedContext: AutoReviewerContext = {
      ...context,
      projectId,
    };
    updateCardContext(updatedContext);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return {
    card,
    filter: context.filter,
    setFilter,
  };
}

export default useArchieQCResultsAdapterCard;
